<template>
  <div>
    <vx-card class="mt-base" :title="activityTitle">
      <p class="mb-5">
        One of the first jobs assigned to hairdressing trainees is to shampoo and condition the
        client’s hair. The process should be relaxing for the client, and it’s important too as it
        will often be the first impression of the salon’s professionalism.
      </p>
      <p class="mb-5">
        The purpose of <strong>shampooing</strong> the hair is to remove dirt, grease, sweat, dead
        skin, and product build-up from the hair, usually preparing for other services in the salon.
      </p>
      <p class="mb-5">
        The purpose of <strong>conditioning</strong> is to smooth the hair’s cuticle layer to
        protect and make the hair easier to handle and comb. Conditioning the hair helps the hair to
        look healthier and helps protect the hair from external elements.
      </p>
      <p class="mb-5">
        Before selecting which shampoos and conditioners to use, you’ll need to assess the client’s
        hair using the information and tests described in the previous section. Products suited to
        the needs of the client’s hair and scalp must be selected.
      </p>
      <p class="mb-5">
        Now, you’ll need someone’s hair to wash for an opportunity to put the theory into practice.
        You can use a friend or family member who is willing to be your guinea pig, or you can apply
        the steps below to your own hair too.
      </p>
      <p class="mb-5">
        Shampooing and conditioning hair are both pretty straightforward procedures.
      </p>
      <p class="mb-5">First, watch the video of a hairdresser washing a client’s hair below:</p>

      <responsive-youtube-wrapper :video="videos[1]" :image="videoTrigger1" />
      <h5 class="mb-5">Your Task:</h5>
      <p class="mb-5">
        Follow the detailed steps below to practise washing your ‘client’s’ hair or your own at
        home. Upload a photo or video of you doing this.
      </p>

      <p class="mb-5">
        1. Ensure the ‘client’ is wearing a gown and a towel to protect their clothing.
      </p>
      <p class="mb-5">2. Ask the client to remove their glasses and any jewellery.</p>
      <p class="mb-5">3. Comb out the hair before you begin.</p>
      <p class="mb-5">4. Have the client lean back into the washbasin and get comfortable.</p>
      <p class="mb-5">5. Remove the hair from the client’s face.</p>
      <p class="mb-5">6. Run the water and check the temperature using your wrist.</p>
      <p class="mb-5">
        7. Wet the client’s hair starting with the scalp - ask the client if the temperature is ok.
      </p>
      <p class="mb-5">
        8. Cup the hand to direct water away from the face and wet hair from the front hairline
        back.
      </p>
      <p class="mb-5">
        9. Apply a suitable amount of shampoo and distribute it evenly throughout hair with palms
        and hands.
      </p>
      <p class="mb-5">
        10. Massage shampoo into the scalp with the pads of your fingers. Use palms to rub hair to
        remove grease and debris.
      </p>
      <p class="mb-5">
        11. Turn the water back on and check the temperature with your wrist again.
      </p>
      <p class="mb-5">
        12. Use the same cupping techniques to protect the client's face from water, rinse while
        working back from the front hairline to remove the shampoo, squeezing out the excess water
        as you go.
      </p>
      <p class="mb-5">
        13. Reapply shampoo a second time and begin the process again, if necessary.
      </p>
      <p class="mb-5">
        14. Repeat the rinsing until all the shampoo has been removed and excess water has been
        squeezed out.
      </p>
      <p class="mb-5">
        15. Wrap a towel around the head to catch any water and prevent it from dripping into the
        eyes or over the face.
      </p>

      <p><strong>Upload your photo or video:</strong></p>
      <br />
      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="media"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/hairdressing/wash_hair_splash.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/yKiJxW1LbvY',
      },
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
